import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {BusinessModel, ProjectModel} from '../../../@models';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import {ApiService} from '../../../@core/service/api.service';

@Component({
  selector: 'ngx-form-project',
  templateUrl: './form-project.component.html',
  styleUrls: ['./form-project.component.scss'],
})
export class FormProjectComponent implements OnInit, OnDestroy, OnChanges {
  @Input() title: string;
  @Input() value: ProjectModel;
  @Input() projects: ProjectModel[];
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() enabled: boolean = true;

  projectName: string;

  projectService: CompleterData;

  constructor(private api: ApiService, private completerService: CompleterService) {
    // this.contactService = this.completerService.local(this.api.reloadBusiness({active: true}), 'name', 'name');
    this.projectService = this.completerService.local(this.projects, 'name', 'name');

  }

  ngOnInit() {
    if (this.value != null) {
      this.projectName = this.value.name;
    }
  }

  ngOnDestroy(): void {
    // this.customerSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value != null && changes.value.currentValue != null)
      this.projectName = changes.value.currentValue.name;
    if (changes.projects != null && changes.projects.currentValue != null)
      this.projectService = this.completerService.local(this.projects, 'name', 'name');


  }

  select(item: CompleterItem): void {
    if (item != null)
      this.valueChange.emit(item.originalObject);
  }
}
